/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import {
  Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output,
} from '@angular/core';
import { UploadType, UppyUploadOption, UppyUploadService } from './uppy-upload.service';

/**
 * Directive for initializing and configuring uploading file using uppy.
 */
@Directive({
  selector: '[bulbUppyUpload]',
  standalone: false,
})
export class UppyUploadDirective implements OnInit, OnDestroy {
  /**
   * emit an event when the file upload complete.
   */
  @Output()
  public uploadComplete: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Container class name where drag and drop need to be attached.
   */
  @Input()
  public dragAndDropTarget: string;

  /**
   * Constructor.
   * @param uppyUploadService
   */
  constructor(private uppyUploadService: UppyUploadService) {
  }

  /**
   * A lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   */
  ngOnInit(): void {
    const uppyUploadOption: UppyUploadOption = {
      type: UploadType.IMAGE,
      dropTarget: `.${this.dragAndDropTarget}`,
      callback: (url) => {
        this.uploadComplete.emit(url);
      },
    };
    this.uppyUploadService.initUppyDashboard(uppyUploadOption);
  }

  /**
   * Click event listener, which trigger the uppy dashboard.
   */
  @HostListener('click')
  openUppyDashboard() {
    this.uppyUploadService.openUppyDashboard();
  }

  /**
   * Lifecycle method, called when the directive is destroyed.
   */
  ngOnDestroy(): void {
    this.uppyUploadService.closeAndUnregisterEvents();
  }
}
